export const testimonialsArray = [
  {
    name: 'John D.',
    date: 'March 1, 2025',
    review:
      'Miss Dominatrixa is truly one-of-a-kind. Her dominance and presence are unmatched. A life-changing experience!',
  },
  {
    name: 'Michael R.',
    date: 'February 20, 2025',
    review:
      'Every session with Miss Dominatrixa is intense and fulfilling. She knows exactly how to push my limits!',
  },
  {
    name: 'Steve P.',
    date: 'January 10, 2025',
    review:
      'I was completely mesmerized by her control and elegance. Her sessions are beyond extraordinary!',
  },
];
